export interface Modulo {
  name: string;
  url: string;
  urlName: string;
  imageUrl: string;
  id:string
}

export const modulosActivos: { [id: string] : Modulo; } = {
    "RalarsaWeb-AperturaHojas": Object.freeze({
        name: "RalarsaWeb-AperturaHojas",
        url: "callcenter",
        urlName: "callcenter",
        imageUrl: "../../assets/icons/HUB_aperturaHojas.jpg",
        id: "0fa67fa5-2da5-4443-8f62-23b49d0d2781"
    }),
    "RalarsaWeb-MiRls": Object.freeze({
    name: "RalarsaWeb-MiRls",
    url: "rls",
    urlName: "rls",
    imageUrl: "../../assets/icons/HUB_miRls.jpg",
    id: "52cff38d-8e39-4f21-88fa-aa9924d6a6ec"
    }),
    "RalarsaWeb-HUB_pedidosExternos": Object.freeze({
    name: "RalarsaWeb-HUB_pedidosExternos",
    url: "peticiones",
    urlName: "peticiones",
    imageUrl: "../../assets/icons/HUB_pedidosExternos.jpg",
    id: "45c80576-f829-4b49-b32f-2ebbcb9279db"
    })
};
